export default __webpack_public_path__ + "static/media/Twitter_gd.049576f6.svg";